












import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';

import api from '../../api';
import ShowCards from '../../components/ui/show-cards/show-cards.vue';
import { IUserShowObject } from '../../../../shared/types';

export default Vue.extend({
  name: 'Shows',

  components: {
    ShowCards,
  },

  data: () => ({
    shows: [] as IUserShowObject[],
  }),

  async created() {
    this.handlePageLoad({
      name: this.$route.name,
    });
    this.requiresLogin();

    this.shows = await api.show.userShows(this.getUser.id, 'tv-show');
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),
  },

  methods: {
    ...mapActions('navigation', [
      'handlePageLoad',
      'requiresLogin',
    ]),
  },
});
